<div class="gallery-page">
  <div class="gallery">
    <nav class="gallery__nav" aria-label="Gallery sections">
      <div *ngFor="let g of groups" class="gallery__nav-group">
        <div class="gallery__nav-title">{{ g.title }}</div>
        <code class="gallery__nav-path">{{ g.path }}</code>
        <button *ngFor="let s of g.sections" type="button" class="br-btn br-btn--link br-btn--sm gallery__nav-link"
                (click)="scrollTo(s.id)">{{ s.label }}</button>
      </div>
    </nav>

    <div class="gallery__content">
      <!-- Theme: one section per token family -->
      <ng-container *ngFor="let f of tokenFamilies">
        <section *ngIf="f.tokens.length" [id]="'gallery-' + f.id" class="br-card">
          <header class="br-card-header">
            <h2 class="br-card-title">{{ f.title }}</h2>
            <code class="br-card-subtitle br-small br-text-muted">styles/theme.css</code>
          </header>
          <div class="br-card-body gallery__stack">
            <p class="br-small br-text-muted br-m-0">{{ f.summary }}</p>
            <div class="gallery__tokens">
              <div *ngFor="let t of f.tokens" class="gallery__token" [ngSwitch]="f.kind">
                <span *ngSwitchCase="'color'" class="gallery__swatch" [style.background]="'var(' + t.name + ')'"></span>
                <span *ngSwitchCase="'font'" class="gallery__sample" [style.font-size]="'var(' + t.name + ')'">Aa</span>
                <span *ngSwitchCase="'space'" class="gallery__space" [style.width]="'var(' + t.name + ')'"></span>
                <span *ngSwitchCase="'shape'" class="gallery__shape"
                      [style.border-radius]="t.name.includes('radius') ? 'var(' + t.name + ')' : null"
                      [style.box-shadow]="t.name.includes('shadow') ? 'var(' + t.name + ')' : null"></span>
                <span *ngSwitchDefault></span>
                <code>{{ t.name }}</code>
                <span class="br-small br-text-muted">{{ t.value }}</span>
              </div>
            </div>
          </div>
        </section>
      </ng-container>

      <!-- Buttons -->
      <section id="gallery-buttons" class="br-card">
        <header class="br-card-header"><h2 class="br-card-title">Buttons</h2></header>
        <div class="br-card-body gallery__stack">
          <div class="gallery__row">
            <button *ngFor="let v of buttonVariants" type="button" [class]="'br-btn br-btn--' + v">{{ v }}</button>
          </div>
          <div class="gallery__row">
            <button *ngFor="let v of buttonVariants" type="button" [class]="'br-btn br-btn--sm br-btn--' + v">{{ v }} sm</button>
          </div>
          <div class="gallery__row">
            <button type="button" class="br-btn br-btn--primary" disabled>Disabled primary</button>
            <button type="button" class="br-btn br-btn--outline-secondary" disabled>Disabled outline</button>
            <button type="button" class="br-btn br-btn--ghost br-btn--sm br-icon-btn" aria-label="Settings"><br-icon>settings</br-icon></button>
            <button type="button" class="br-btn br-btn--primary"><br-icon>add</br-icon> New record</button>
            <button type="button" class="br-btn-close" aria-label="Close"></button>
          </div>
          <div class="br-btn-group" role="group" aria-label="View">
            <button *ngFor="let v of views" type="button" class="br-btn br-btn--sm br-btn--outline-secondary br-interactive"
                    [attr.aria-pressed]="currentView === v"
                    (click)="currentView = v">{{ v }}</button>
          </div>
        </div>
      </section>

      <!-- Badges and alerts -->
      <section id="gallery-badges" class="br-card">
        <header class="br-card-header"><h2 class="br-card-title">Badges &amp; alerts</h2></header>
        <div class="br-card-body gallery__stack">
          <div class="gallery__row">
            <span class="br-badge br-badge--primary">Primary</span>
            <span class="br-badge br-badge--neutral">Neutral</span>
            <span class="br-badge br-badge--ai">AI</span>
            <span class="br-badge br-badge--primary br-badge--sm">Small</span>
            <span class="br-badge br-rounded-pill br-badge--primary">Pill</span>
          </div>
          <div class="br-alert">Default alert with neutral information.</div>
          <div class="br-alert br-alert--success">Saved successfully.</div>
          <div class="br-alert br-alert--danger">Something went wrong. Try again.</div>
          <div class="gallery__row br-small">
            <span class="br-text-muted">muted</span>
            <span class="br-text-secondary">secondary</span>
            <span class="br-text-success">success</span>
            <span class="br-text-warning">warning</span>
            <span class="br-text-danger">danger</span>
            <span class="br-fw-bold">bold</span>
            <span class="br-fst-italic">italic</span>
          </div>
        </div>
      </section>

      <!-- Cards -->
      <section id="gallery-cards" class="br-card">
        <header class="br-card-header"><h2 class="br-card-title">Cards</h2></header>
        <div class="br-card-body gallery__grid">
          <div class="br-card">
            <div class="br-card-header"><h3 class="br-card-title">Card title</h3><div class="br-card-subtitle br-text-muted">Subtitle</div></div>
            <div class="br-card-body">Standard card body content.</div>
          </div>
          <div class="br-card br-card--dense">
            <div class="br-card-header"><h3 class="br-card-title">Dense card</h3></div>
            <div class="br-card-body">Tighter spacing for side panels.</div>
          </div>
          <div class="br-card br-shadow">
            <div class="br-card-body">Card with shadow and no header.</div>
          </div>
        </div>
      </section>

      <!-- Form fields -->
      <section id="gallery-forms" class="br-card">
        <header class="br-card-header"><h2 class="br-card-title">Form fields</h2></header>
        <div class="br-card-body">
          <div class="br-form-section">
            <div class="br-form-row">
              <label class="br-form-label" for="g-text">Text <span class="br-required-mark">*</span></label>
              <input id="g-text" class="br-form-control" placeholder="Type something" [(ngModel)]="text">
            </div>
            <div class="br-form-row">
              <label class="br-form-label" for="g-text-sm">Small text</label>
              <input id="g-text-sm" class="br-form-control br-form-control--sm" placeholder="Small">
            </div>
            <div class="br-form-row">
              <label class="br-form-label" for="g-disabled">Disabled</label>
              <input id="g-disabled" class="br-form-control" value="Read only" disabled>
            </div>
            <div class="br-form-row">
              <label class="br-form-label" for="g-select">Select</label>
              <select id="g-select" class="br-form-select" [(ngModel)]="select">
                <option value="a">Option A</option><option value="b">Option B</option><option value="c">Option C</option>
              </select>
            </div>
            <div class="br-form-row">
              <label class="br-form-label" for="g-select-sm">Small select</label>
              <select id="g-select-sm" class="br-form-select br-form-select--sm br-w-auto"><option>One</option><option>Two</option></select>
            </div>
            <div class="br-form-row">
              <label class="br-form-label" for="g-area">Textarea</label>
              <textarea id="g-area" class="br-form-control" rows="3"></textarea>
            </div>
            <div class="br-form-check">
              <input id="g-check" type="checkbox" class="br-form-check-input" [(ngModel)]="checked">
              <label class="br-form-check-label" for="g-check">Checkbox ({{ checked ? 'on' : 'off' }})</label>
            </div>
          </div>
        </div>
      </section>

      <!-- Confirmation dialog -->
      <section id="gallery-confirmation-dialog" class="br-card">
        <header class="br-card-header"><h2 class="br-card-title">Confirmation dialog</h2><code class="br-card-subtitle br-small br-text-muted">shared/ui/confirmation-dialog</code></header>
        <div class="br-card-body gallery__row">
          <button type="button" class="br-btn br-btn--outline-secondary" (click)="confirm(false)">Confirmation</button>
          <button type="button" class="br-btn br-btn--outline-danger" (click)="confirm(true)">Danger confirmation</button>
        </div>
      </section>

      <!-- Data filter -->
      <section id="gallery-data-filter" class="br-card">
        <header class="br-card-header"><h2 class="br-card-title">Data filter</h2><code class="br-card-subtitle br-small br-text-muted">shared/ui/data-filter</code></header>
        <div class="br-card-body gallery__stack">
          <app-data-filter contextKey="ui-gallery-filter" [fields]="filterFields" [values]="filterValues"
                           (applied)="filterValues = $event"></app-data-filter>
          <code class="br-small">{{ filterValues | json }}</code>
        </div>
      </section>

      <!-- Data list -->
      <section id="gallery-data-list" class="br-card">
        <header class="br-card-header"><h2 class="br-card-title">Data list</h2><code class="br-card-subtitle br-small br-text-muted">shared/ui/data-list</code></header>
        <div class="br-card-body gallery__list">
          <app-data-list contextKey="ui-gallery-list" [fetch]="fetch" [filters]="filterValues" [pageSize]="10">
            <ng-template dataListItem let-row>
              <strong>{{ row.name }}</strong>
              <div class="br-text-muted">{{ row.city }} · {{ row.status }}</div>
            </ng-template>
            <ng-template dataListDetail let-row>
              <div>Value: {{ row.value | number }}</div>
            </ng-template>
          </app-data-list>
        </div>
      </section>

      <!-- Data table -->
      <section id="gallery-data-table" class="br-card">
        <header class="br-card-header"><h2 class="br-card-title">Data table</h2><code class="br-card-subtitle br-small br-text-muted">shared/ui/data-table</code></header>
        <div class="br-card-body gallery__table">
          <app-data-table contextKey="ui-gallery-table" [columns]="columns" [fetch]="fetch" [filters]="filterValues"
                          columnPickerKey="ui-gallery" [resizableColumns]="true" selectable editable
                          addLabel="New" [pageSize]="10" [pageSizeOptions]="[10, 25]" [rowActions]="rowActions">
            <div dt-bulk-actions>
              <button type="button" class="br-btn br-btn--sm br-btn--outline-danger">Bulk action</button>
            </div>
            <ng-template dtCell="id" let-r>{{ r.id }}</ng-template>
            <ng-template dtCell="name" let-r><span class="br-cell-primary">{{ r.name }}</span></ng-template>
            <ng-template dtCell="status" let-r><span class="br-cell-pill">{{ r.status }}</span></ng-template>
            <ng-template dtCell="city" let-r>{{ r.city }}</ng-template>
            <ng-template dtCell="value" let-r>{{ r.value | number }}</ng-template>
          </app-data-table>
        </div>
      </section>

      <ng-template #rowActions let-r>
        <button class="br-btn br-btn--ghost br-btn--sm br-icon-btn" aria-label="Row actions"
                [brMenuTriggerFor]="contextMenu" [brMenuTriggerData]="{ $implicit: r.name }"><br-icon>more_vert</br-icon></button>
      </ng-template>

      <!-- Date field -->
      <section id="gallery-date-field" class="br-card">
        <header class="br-card-header"><h2 class="br-card-title">Date field</h2><code class="br-card-subtitle br-small br-text-muted">shared/ui/date-field</code></header>
        <div class="br-card-body gallery__grid">
          <div>
            <app-date-field label="Date" [(ngModel)]="date"></app-date-field>
            <div class="br-small br-text-muted">Value: {{ date ?? 'null' }}</div>
          </div>
          <div>
            <app-date-field label="Date and time" mode="datetime" [(ngModel)]="dateTime"></app-date-field>
            <div class="br-small br-text-muted">Value: {{ dateTime ?? 'null' }}</div>
          </div>
          <app-date-field label="Disabled date" [disabled]="true"></app-date-field>
        </div>
      </section>

      <!-- Icons -->
      <section id="gallery-icon" class="br-card">
        <header class="br-card-header"><h2 class="br-card-title">Icons</h2><code class="br-card-subtitle br-small br-text-muted">shared/ui/icon</code></header>
        <div class="br-card-body gallery__stack">
          <div class="gallery__row">
            <span *ngFor="let name of fontIcons" class="gallery__icon"><br-icon>{{ name }}</br-icon><code>{{ name }}</code></span>
          </div>
          <div class="gallery__row">
            <span *ngFor="let name of svgIcons" class="gallery__icon"><br-icon [svgIcon]="name"></br-icon><code>{{ name }}</code></span>
          </div>
        </div>
      </section>

      <!-- Action menus -->
      <section id="gallery-menu" class="br-card">
        <header class="br-card-header"><h2 class="br-card-title">Action menus</h2><code class="br-card-subtitle br-small br-text-muted">shared/ui/menu</code></header>
        <div class="br-card-body gallery__row">
          <button class="br-btn br-btn--outline-secondary" [brMenuTriggerFor]="basicMenu">Basic menu</button>
          <button class="br-btn br-btn--ghost br-icon-btn" aria-label="More actions" [brMenuTriggerFor]="basicMenu"
                  [brMenuPosition]="{ x: 'before' }"><br-icon>more_vert</br-icon></button>
          <button class="br-btn br-btn--outline-secondary" [brMenuTriggerFor]="currentMenu">View: {{ currentView }}</button>
          <button class="br-btn br-btn--outline-secondary" [brMenuTriggerFor]="prefixMenu" [brMenuPosition]="{ y: 'above' }">Colour markers (above)</button>
          <button class="br-btn br-btn--outline-secondary" [brMenuTriggerFor]="contextMenu" [brMenuTriggerData]="{ $implicit: 'Row 42' }">With context data</button>
          <button class="br-btn br-btn--outline-secondary" [brMenuTriggerFor]="basicMenu" disabled>Disabled trigger</button>
        </div>
      </section>

      <ng-template #basicMenu>
        <br-menu aria-label="Actions">
          <button brMenuItem label="Edit" icon="edit"></button>
          <button brMenuItem label="Duplicate" icon="content_copy"></button>
          <button brMenuItem label="Archive (disabled)" icon="archive" disabled></button>
          <button brMenuItem label="Delete" icon="delete"></button>
        </br-menu>
      </ng-template>
      <ng-template #currentMenu>
        <br-menu aria-label="View">
          <button *ngFor="let v of views" brMenuItem [label]="v" [current]="currentView === v"
                  (triggered)="currentView = v"></button>
        </br-menu>
      </ng-template>
      <ng-template #prefixMenu>
        <br-menu aria-label="Territories">
          <button *ngFor="let c of colors; let i = index" brMenuItem [label]="'Territory ' + (i + 1)"><span brMenuItemPrefix aria-hidden="true" class="gallery__dot" [style.background]="c"></span></button>
        </br-menu>
      </ng-template>
      <ng-template #contextMenu let-row>
        <br-menu aria-label="Row actions">
          <button brMenuItem [label]="'Open ' + row" icon="open_in_new"></button>
        </br-menu>
      </ng-template>

      <!-- Form popovers -->
      <section id="gallery-popover" class="br-card">
        <header class="br-card-header"><h2 class="br-card-title">Form popovers</h2><code class="br-card-subtitle br-small br-text-muted">shared/ui/popover</code></header>
        <div class="br-card-body gallery__row">
          <button class="br-btn br-btn--outline-secondary" [brPopoverFor]="formPopover" brPopoverLabel="Quick edit"><br-icon>tune</br-icon> Quick edit</button>
          <span class="br-small br-text-muted">Name: {{ popoverName || '—' }}, Status: {{ popoverStatus }}</span>
        </div>
      </section>

      <ng-template #formPopover let-popover="popover">
        <div class="br-p-3 br-flex br-flex-column br-gap-2 gallery__popover">
          <label class="br-form-label" for="g-pop-name">Name</label>
          <input id="g-pop-name" class="br-form-control br-form-control--sm" [(ngModel)]="popoverName">
          <label class="br-form-label" for="g-pop-status">Status</label>
          <select id="g-pop-status" class="br-form-select br-form-select--sm" [(ngModel)]="popoverStatus">
            <option>Active</option><option>Pending</option><option>Closed</option>
          </select>
          <div class="br-flex br-justify-end br-gap-2">
            <button type="button" class="br-btn br-btn--primary br-btn--sm" (click)="popover.close()">Apply</button>
          </div>
        </div>
      </ng-template>

      <!-- Signature pad -->
      <section id="gallery-signature-pad" class="br-card">
        <header class="br-card-header"><h2 class="br-card-title">Signature pad</h2><code class="br-card-subtitle br-small br-text-muted">shared/ui/signature-pad</code></header>
        <div class="br-card-body">
          <app-signature-pad (signatureChange)="signature = $event"></app-signature-pad>
          <div class="br-small br-text-muted">{{ signature ? 'Signature captured' : 'No signature' }}</div>
        </div>
      </section>

      <!-- Time field -->
      <section id="gallery-time-field" class="br-card">
        <header class="br-card-header"><h2 class="br-card-title">Time field</h2><code class="br-card-subtitle br-small br-text-muted">shared/ui/time-field</code></header>
        <div class="br-card-body gallery__grid">
          <div>
            <app-time-field label="Time" [(ngModel)]="time"></app-time-field>
            <div class="br-small br-text-muted">Value: {{ time ?? 'null' }}</div>
          </div>
        </div>
      </section>

      <!-- Typed confirmation dialog -->
      <section id="gallery-typed-confirmation-dialog" class="br-card">
        <header class="br-card-header"><h2 class="br-card-title">Typed confirmation dialog</h2><code class="br-card-subtitle br-small br-text-muted">shared/ui/typed-confirmation-dialog</code></header>
        <div class="br-card-body gallery__row">
          <button type="button" class="br-btn br-btn--danger" (click)="confirmTyped()">Typed confirmation</button>
        </div>
      </section>

      <!-- Material controls still in use -->
      <section id="gallery-material" class="br-card">
        <header class="br-card-header"><h2 class="br-card-title">Material (not migrated)</h2></header>
        <div class="br-card-body gallery__stack">
          <mat-tab-group [mat-stretch-tabs]="false" class="workspace-page__tabs">
            <mat-tab label="First">First tab content.</mat-tab>
            <mat-tab label="Second">Second tab content.</mat-tab>
          </mat-tab-group>
          <div class="gallery__row">
            <button type="button" class="br-btn br-btn--outline-secondary" matTooltip="Material tooltip">Tooltip</button>
            <mat-slide-toggle [(ngModel)]="checked">Slide toggle</mat-slide-toggle>
            <mat-checkbox [(ngModel)]="checked">Material checkbox</mat-checkbox>
            <mat-button-toggle-group [(ngModel)]="currentView" aria-label="View">
              <mat-button-toggle *ngFor="let v of views" [value]="v">{{ v }}</mat-button-toggle>
            </mat-button-toggle-group>
          </div>
          <mat-radio-group [(ngModel)]="select" class="gallery__row" aria-label="Option">
            <mat-radio-button value="a">A</mat-radio-button>
            <mat-radio-button value="b">B</mat-radio-button>
            <mat-radio-button value="c">C</mat-radio-button>
          </mat-radio-group>
          <div class="gallery__row">
            <mat-form-field appearance="outline">
              <mat-label>Material input</mat-label>
              <input matInput [(ngModel)]="text">
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Material select</mat-label>
              <mat-select [(ngModel)]="select">
                <mat-option value="a">Option A</mat-option><mat-option value="b">Option B</mat-option><mat-option value="c">Option C</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Autocomplete</mat-label>
              <input matInput [matAutocomplete]="cityAuto">
              <mat-autocomplete #cityAuto>
                <mat-option *ngFor="let c of filterFields[1].options" [value]="c.label">{{ c.label }}</mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <mat-chip-set><mat-chip>Chip one</mat-chip><mat-chip>Chip two</mat-chip></mat-chip-set>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          <mat-spinner diameter="28"></mat-spinner>
        </div>
      </section>
    </div>
  </div>
</div>
